import React from "react";

interface Props {
    height?: `${number}rem`;
    width?: `${number}rem`;
    className?: string;
}

const Skeleton = ({ height = "1rem", width = "20rem", className }: Props) => (
    <span className={`animate-pulse block bg-pine-700 rounded ${className} max-w-[90%]`} style={{ width, height }} />
);

export default Skeleton;
